<form [formGroup]="nameForm" id="emailForm" (ngSubmit)="onSubmit($event)">
  <fieldset class="row">
    <div class="col-6">
      <label for="firstname">{{ 'Template.SettingsComponent.label_firstName' | translate }}*</label>
      <input type="text" class='form-control' name="firstname" id="firstname" formControlName="firstname" maxlength="50" autocomplete="off"
        [class]="mode == FORM_COMP_MODES.DISPLAY ? 'form-control-plaintext' : 'form-control'"
        [readonly]="mode == FORM_COMP_MODES.DISPLAY"/>
    </div>
    <div class="col-6">
      <label for="lastname">{{ 'Template.SettingsComponent.label_lastName' | translate }}*</label>
      <input type="text" class='form-control' name="lastname" id="lastname" formControlName="lastname" maxlength="50" autocomplete="off" [class]="mode == FORM_COMP_MODES.DISPLAY ? 'form-control-plaintext' : 'form-control'"
        [readonly]="mode == FORM_COMP_MODES.DISPLAY"/>
    </div>
  </fieldset>

  @if (error) {
    <p class="alert alert-danger text-center mt-3">
      <strong>{{error}}</strong>
    </p>
  }

  @if (mode == FORM_COMP_MODES.CREATE || mode == FORM_COMP_MODES.EDIT) {
    <div class="mt-2 d-flex justify-content-center">
      <!-- <label>{{ 'Template.PasswordChangeComponent.label_commonFieldsMarkedAreRequired' | translate }}</label> -->
      <label></label>
      <button type="submit" class="btn btn-success d-block w-100" [disabled]="!nameForm.valid">
        {{ 'Template.SettingsComponent.btn_save' | translate }}
        <fa-icon icon="chevron-right"></fa-icon>
        @if (loading) {
          <fa-icon icon="spinner" animation="spin"></fa-icon>
        }
      </button>
    </div>
  }
</form>
